import { useMemo } from "react";
import { useGetStaffByCompanyQuery } from "../redux/services/staffApi";
import { useGetRolesDropdownQuery } from "../redux/services/settingsRoleApi";

/**
 * Company staff as select options labelled "Name (Role)", so whoever assigns
 * staff to a service can tell drivers apart from other roles.
 *
 * The by-company endpoint only carries each user's role_id, so the name is
 * resolved against the (unpaginated) roles dropdown list.
 */
export const useStaffOptions = () => {
  const { data: staffByCompanyData } = useGetStaffByCompanyQuery();
  const { data: rolesData } = useGetRolesDropdownQuery();

  return useMemo(() => {
    const roles: any[] = Array.isArray(rolesData?.data) ? rolesData.data : [];
    const roleMap: Record<string, string> = {};
    roles.forEach((r) => {
      if (r?.id && r?.name) roleMap[r.id] = r.name;
    });

    return (staffByCompanyData?.data?.staff_members ?? []).map((m: any) => {
      const name = m.user?.name ?? m.user?.email ?? "Unknown";
      const role = m.user?.role?.name ?? roleMap[m.user?.role_id];
      return {
        label: role ? `${name} (${role})` : name,
        value: m.id,
      };
    });
  }, [staffByCompanyData, rolesData]);
};
